import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { PROJECT_API } from "../apiRoutes";

interface mutateProps {
  projectId: string;
  planId: string;
  data: any
}

const mutateAddTask = async ({projectId, planId, data}: mutateProps) => {
  return await axiosAuth.post(`${PROJECT_API}/${projectId}/plans/${planId}/tasks`, data);
};

const useAddTaskMutation = (
  queryParams?: UseMutationOptions<any, Error, mutateProps, unknown>
) =>
  useMutation({
    mutationFn: mutateAddTask,
    ...queryParams,
  });

export default useAddTaskMutation;
